import { ContentType, TranslatableField } from 'fourwaves-shared';

export interface CreateContentModelBase {
  type: ContentType;
  pageId: string;
  data: any;
  settings: any;
}

interface CreateContentModel<TData, TSettings> extends CreateContentModelBase {
  data: TData;
  settings: TSettings;
}

export interface TextData {
  htmlContent: TranslatableField;
  button?: ButtonData;
}
export interface TextSettings {
  withButton: boolean;
  button?: ButtonSettings;
}
export interface CreateTextContentModel extends CreateContentModel<TextData, TextSettings> {
  type: ContentType.RichTextEditor;
}

export interface TranslatableData<T> {
  en: T;
  fr: T;
}

export interface FocalPoint {
  x: TranslatableData<number>;
  y: TranslatableData<number>;
  zoom: TranslatableData<number>;
}
export interface ImageData {
  focalPoint: FocalPoint;
  originalUrl: TranslatableField;
}

export enum ImageSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}
export enum ImagePosition {
  Left = 'Left',
  Top = 'Top',
  Right = 'Right',
  Bottom = 'Bottom',
}
export interface ImageSettings {
  size: ImageSize;
  position: ImagePosition;
}

export interface ButtonData {
  url: TranslatableField;
  label: TranslatableField;
}

export enum ButtonStyle {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Link = 'Link',
}
export interface ButtonSettings {
  style: ButtonStyle;
}

export interface TextImageData {
  image: ImageData;
  htmlContent: TranslatableField;
  button?: ButtonData;
}

export enum TextVerticalAlignment {
  Center = 'Center',
  Top = 'Top',
}

export interface TextImageSettings {
  image: ImageSettings;
  withButton: boolean;
  textVerticalAlignment: TextVerticalAlignment;
  button?: ButtonSettings;
}

export interface CreateTextImageContentModel extends CreateContentModel<TextImageData, TextImageSettings> {
  type: ContentType.TextImage;
}
